/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {Link as RouteLink} from 'react-router-dom'

// Components
import {
    BreadcrumbItem as ChakraBreadcrumbItem,
    BreadcrumbLink as ChakraBreadcrumbLink
} from '@salesforce/retail-react-app/app/components/shared/ui'

import Breadcrumb from '@app/components/breadcrumb'

/**
 * PDCBreadcrumb component
 * This component is used to display the breadcrumb for the PDC pages
 *
 * @param {object} currentPage
 * @returns
 */
const PDCBreadcrumb = ({
    currentPage,
    homePage,
    homeUrl,
    isBlog,
    isHomePage,
    isCategoryPage,
    isRootPage,
    ...props
}) => {
    return (
        <Breadcrumb
            pageData={{currentPage: currentPage, homePage: homePage, homeUrl: homeUrl}}
            type="content"
            {...props}
        >
            {/* PDCBlogSubmenu component */}
            {isBlog &&
                homePage &&
                (isHomePage ? (
                    <ChakraBreadcrumbItem isCurrentPage>
                        <ChakraBreadcrumbLink color="fullBlack">
                            {homePage?.name}
                        </ChakraBreadcrumbLink>
                    </ChakraBreadcrumbItem>
                ) : (
                    <ChakraBreadcrumbItem>
                        <ChakraBreadcrumbLink as={RouteLink} to={homeUrl}>
                            {homePage?.name}
                        </ChakraBreadcrumbLink>
                    </ChakraBreadcrumbItem>
                ))}

            {isBlog && !isHomePage && (
                <ChakraBreadcrumbItem isCurrentPage>
                    <ChakraBreadcrumbLink color="fullBlack">
                        {currentPage?.name}
                    </ChakraBreadcrumbLink>
                </ChakraBreadcrumbItem>
            )}
            {/* End: PDCBlogSubmenu component */}

            {/* PDCSubmenu component */}
            {isRootPage && (
                <ChakraBreadcrumbItem isCurrentPage={true}>
                    <ChakraBreadcrumbLink color="fullBlack">
                        {currentPage?.name}
                    </ChakraBreadcrumbLink>
                </ChakraBreadcrumbItem>
            )}
        </Breadcrumb>
    )
}

PDCBreadcrumb.propTypes = {
    currentPage: PropTypes.object,
    homePage: PropTypes.object,
    homeUrl: PropTypes.string,
    isBlog: PropTypes.bool,
    isHomePage: PropTypes.bool,
    isCategoryPage: PropTypes.bool,
    isRootPage: PropTypes.bool
}

export default PDCBreadcrumb
